import React, { useCallback } from 'react';
import { FormattedDate } from 'react-intl';

import { Link } from '@tmapy/style-guide';

import { useAppContext, useHistoryAction } from '../../hooks';
import { UserListResponse } from '../../openapi/types/UserList';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { RouteId } from '../../routes';

export const UserListItem: React.FC<UserListResponse> = (props) => {
  const { appType } = useAppContext();
  const routeToUserDetail = useHistoryAction('prejimkaUserEdit', { id: props.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('prejimkaUserEdit' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }
      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToUserDetail();
      }
    },
    [routeToUserDetail],
  );

  return (
    <tr onClick={handleClick}>
      <td>
        <div className='sg-u-type-base sg-u-type-bold'>{`${props.name} ${props.surname}`}</div>
        <div className='sg-u-type-xsm sg-u-c-body-darkest'>
          {props.roles.map((role) => role.label).join(', ')}
        </div>
      </td>
      <td>
        <Link href={`mailto:${props.email}`} severity='colorful'>
          {props.email}
        </Link>
      </td>
      <td>{props.organizations.map((organization) => organization.name).join(', ')}</td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        <FormattedDate value={props.date_joined} />
      </td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        <FormattedDate value={props.last_login ?? undefined} />
      </td>
    </tr>
  );
};
